import React, { FC } from "react";
import {
  BackToLoginWrapper,
  Body,
  ButtonWrapper,
  Container,
  Header,
  HeaderText,
  Logo,
  ErrorMessage,
} from "./elements";
import logo from "../../../assets/images/new_logo_dark.svg";
import { Formik } from "formik";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { Button } from "../../atoms/Button";
import { Label } from "../../atoms/Label";
import { Loader } from "../../atoms/Loader";
import { ForgotPasswordSchema } from "./validation";

export type ForgotPasswordProps = {
  onSubmit: (email: string) => void;
  returnToLogin: () => void;
  isLoading: boolean;
};

const ForgotPasswordForm: FC<ForgotPasswordProps> = ({
  onSubmit,
  returnToLogin,
  isLoading,
}) => {
  return (
    <Container>
      <Header>
        <Logo src={logo} alt="logo" />
        <HeaderText>Recover your password</HeaderText>
      </Header>
      <Body>
        <p>
          Don’t worry. Please enter the email address for your account. We'll send you the instructions on how to reset your password.
        </p>
        <Formik
          onSubmit={(values) => onSubmit(values.email)}
          initialValues={{ email: "" }}
          validationSchema={ForgotPasswordSchema}
        >
          {({ values, handleChange, handleSubmit, errors }) => (
            <form onSubmit={handleSubmit}>
              <InputWithLabel
                name="email"
                onChange={handleChange("email")}
                value={values.email}
                label={"Email Address"}
                type={"default"}
              />
              {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
              <ButtonWrapper>
                {isLoading ? (
                  <Loader />
                ) : (
                  <Button type="primary" onClick={handleSubmit}>
                    Submit
                  </Button>
                )}
              </ButtonWrapper>
            </form>
          )}
        </Formik>
        <BackToLoginWrapper>
          <Label onClick={returnToLogin}>Return To Login</Label>
        </BackToLoginWrapper>
      </Body>
    </Container>
  );
};

export default ForgotPasswordForm;
